// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
declare var InovxLoader: any;

interface FilterItems extends ReactProps {
    filterItems: any[];
    defaultItem?: any;
    onClick: any;
}

function calculateItems(props: FilterItems) {
    var groupName: string = 'filterListGroup' + Math.floor(Math.random() * 50).toString();
    var defaultItemIndex = -1;
    var tempId: string, listKey: string, itemId: string;

    if (props.defaultItem !== undefined) {
        defaultItemIndex = props.filterItems.indexOf(props.defaultItem);
    }

    var tempItems: any[] = [];
    for (var i = 0; i < this.props.filterItems.length; i++) {
        let tempItem: any;
        tempId = Math.floor(Math.random() * 1000).toString();
        listKey = (new Date()).getTime() + tempId;
        itemId = 'rad' + tempId;
        tempItem = this.props.filterItems[i];

        tempItems.push(
            <li className="filter-item" key={listKey}>
                <input type='radio' defaultChecked={i === defaultItemIndex} name={groupName} id={itemId} onClick={() => props.onClick(tempItem)} />
                <label htmlFor={itemId}>{tempItem.display}</label>
            </li>
        );
    }

    return tempItems;
}

const Filter = (props: FilterItems) => (
    <div>
        <ul>
            {calculateItems(props) }
        </ul>
    </div>
);

export default Filter;